import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontAngkor, fontFredoka } from "shared/lib/styles";

import { Button } from "scmp-app/components/posties/button";

import GroundMobileImage from "./ground-mobile.svg?url";
import GroundImage from "./ground.svg?url";
import PeterMobileImage from "./peter-mobile.png";
import PeterImage from "./peter.png";

export const Container = styled.div``;

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;

  max-inline-size: 414px;
  margin-block-start: 36px;
  margin-inline: 24px;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 48px;
    margin-inline-start: 48px;
  }
`;

export const Title = styled.div`
  margin-block-end: 16px;

  color: #1b4191;
  font-weight: 400;
  font-size: 24px;
  font-family: ${fontAngkor};
  line-height: 28.8px;
  letter-spacing: -0.03em;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 20px;

    font-size: 36px;
    line-height: 43.2px;
    letter-spacing: -0.03em;
    text-align: start;
  }
`;

export const Description = styled.div`
  max-inline-size: 400px;
  margin-block-end: 24px;

  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 21.6px;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 320px;
    margin-block-end: 32px;

    font-size: 20px;
    line-height: 24px;
    text-align: start;
  }
`;

export const StyledButton = styled(Button)`
  inline-size: 178px;
  padding-block: 12px 13px;

  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.03em;
  white-space: nowrap;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 12px 13px;
    padding-inline: 24px;

    font-size: 18px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    align-items: flex-start;
  }
`;

export const MoreQuizzesButton = styled(BaseLink)`
  inline-size: 178px;
  padding-block: 12px 13px;

  color: #000000;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 18px;
  letter-spacing: 0.03em;
  white-space: nowrap;
  text-align: center;

  border: 2px solid #000000;
  border-radius: 100px;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 18px;
    line-height: 18px;
  }
`;

export const ImageGround = styled.div`
  position: absolute;
  inset-block-end: -2px;

  inline-size: 100%;

  background-image: url(${GroundMobileImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  aspect-ratio: 332/335;

  ${props => props.theme.breakpoints.up("desktop")} {
    background-image: url(${GroundImage});
    aspect-ratio: 676/335;
  }
`;

export const ImagePeterContainer = styled.div`
  position: absolute;
  inset-block-start: 30%;
  inset-inline-start: 50%;

  block-size: 53%;

  transform: translateX(-50%);

  aspect-ratio: 260/229;

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-start: -44%;
    inset-inline: auto 19px;

    block-size: 123.5%;
    max-inline-size: none;

    transform: translateX(0);
    aspect-ratio: 303/411;
  }
`;

export const ImagePeter = styled.div`
  inline-size: 100%;
  block-size: 100%;

  background-image: url(${PeterMobileImage.src});
  background-repeat: no-repeat;
  background-size: contain;
  ${props => props.theme.breakpoints.up("desktop")} {
    background-image: url(${PeterImage.src});
  }
`;
